import { AxiosError, AxiosResponse } from "axios";
import { ILaunchOsObjectParams, ISendPdfOs } from "../../interfaces/IOs";
import protheusProvider from "../providers/protheus.provider";
import nodeProvider from "../providers/node.provider";

export class OsService {
  public async getOs(os: number, analista: string, token: string): Promise<AxiosResponse> {
    try {
      const response = await nodeProvider.get(`os/${os}`, {
        params: {
          analista,
          token
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async launchOs(objectParams: ILaunchOsObjectParams): Promise<AxiosResponse> {
    try {
      const response = await nodeProvider.post(`os`, objectParams);
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async deleteOS(id: string | number, token: string): Promise<AxiosResponse> {
    try {
      const response = await nodeProvider.delete(`os/${id}`, {
        params: {
          token
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async sendPdfOS(objectParams: ISendPdfOs): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.post(`WSSENDMAIL`, objectParams);
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }
}